import { CategoryStyles, Styles } from './styles';
import {
  FaCalendarAlt,
  FaGlobe,
  FaGraduationCap,
  FaMoneyBillWave,
  FaSortAmountUp,
  FaUserClock,
  FaLocationArrow,
} from 'react-icons/fa';
import { CoursesSkillLevelMap, CoursesSubscriptionTypeMap } from '../../../utils/constraints';
import Link from 'next/link';
import { colors } from '../../../styles/colors';
import { trackPixelEvent } from '../../../utils/facebook-pixel';

export type CourseDetailsProps = {
  startDate?: string;
  endDate?: string;
  category: string;
  subscriptionType: string;
  preSubscription: boolean;
  skillLevel?: string;
  slug: string;
  price?: number;
  placeName?: string;
  placeAddress?: string;
  googleMapsUrl?: string;
  showButton: boolean;
  remote?: boolean;
  period?: string;
  maxStudents?: number;
  confirmedStudents?: number;
};

const CourseDetails: React.FC<CourseDetailsProps> = ({
  category,
  preSubscription,
  skillLevel,
  slug,
  showButton,
  subscriptionType,
  price,
  remote,
  period,
  placeName,
  placeAddress,
  googleMapsUrl,
  maxStudents,
  confirmedStudents,
}) => {
  return (
    <Styles>
      <h5 className="title">Detalhes do curso</h5>
      <ul className="list-unstyled feature-list">
        {/* <li>
          <FaCalendar style={{ marginRight: '5px' }} fill={colors.blue} /> Início:
          <span>{startDate}</span>
        </li>
        <li>
          <FaCalendar style={{ marginRight: '5px' }} fill={colors.blue} /> Fim: <span>{endDate}</span>
        </li> */}
        {skillLevel && (
          <li>
            <FaSortAmountUp style={{ marginRight: '5px' }} fill={colors.blue} /> Nível de
            habilidade:
            <span style={{ textTransform: 'capitalize' }}>
              {CoursesSkillLevelMap[skillLevel] as string}
            </span>
          </li>
        )}
        <li>
          <CategoryStyles>
            <div>
              <FaGraduationCap style={{ marginRight: '7px' }} fill={colors.blue} />
              Categoria:
            </div>
            <span style={{ textTransform: 'capitalize' }}>
              {category === 'inteligencia_artificial' ? 'Inteligência Artificial' : category}
            </span>
          </CategoryStyles>
        </li>
        {price !== null && price !== 0 && (
          <li>
            <FaMoneyBillWave style={{ marginRight: '5px' }} fill={colors.blue} /> Investimento:{' '}
            {subscriptionType === 'free' ? (
              <span>{CoursesSubscriptionTypeMap[subscriptionType]}</span>
            ) : (
              <span>{price?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
            )}
          </li>
        )}

        {!!maxStudents && (
          <>
            <li>
              <FaUserClock style={{ marginRight: '5px' }} fill={colors.blue} /> Vagas restantes:{' '}
              <span>{confirmedStudents ? maxStudents - confirmedStudents : maxStudents}</span>
            </li>
          </>
        )}

        {period && (
          <li style={{ display: 'inline-block', width: '100%' }}>
            <FaCalendarAlt style={{ marginRight: '5px' }} fill={colors.blue} /> Período:{' '}
            <span>{period}</span>
          </li>
        )}

        <li>
          <FaGlobe style={{ marginRight: '5px' }} fill={colors.blue} />
          {remote ? 'Treinamento totalmente online' : 'Treinamento presencial em Juiz de Fora'}
        </li>

        {placeName && (
          <li style={{ display: 'inline-block', width: '100%' }}>
            <FaLocationArrow style={{ marginRight: '5px' }} fill={colors.blue} /> Local:{' '}
            <span>
              <b>
                <a href={googleMapsUrl} target="_blank" rel="noreferrer">
                  {placeName}
                </a>
              </b>{' '}
              - {placeAddress}
            </span>
          </li>
        )}

        {showButton && (
          <li>
            <Link
              href={{
                pathname: `/cursos/[slug]/${preSubscription ? 'pre-inscricao' : 'inscricao'}`,
                query: { slug: slug },
              }}
            >
              <button
                type="button"
                className="enroll-btn"
                onClick={() => {
                  if (price && price > 0) {
                    trackPixelEvent('AddToCart');
                  }
                }}
              >
                {preSubscription ? 'Pré-inscrever' : 'Inscreva-se'}
              </button>
            </Link>
          </li>
        )}
      </ul>
    </Styles>
  );
};

export default CourseDetails;
